
export enum AuthorityEnum {
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
}

export class Authority {
  authority: AuthorityEnum;
}

export class EmployeeUser {
  id: number;
  enabled: boolean;
  username: string;
  email: string;
  authorities: Array<Authority>;

  constructor() {}

}
